import { createSlice } from '@reduxjs/toolkit';
import { DELIVERY_METHOD_NAMES, DELIVERY_METHOD_CODE_MAP } from '../constants';
export const initialNotificationState = {
  FLOATING: [],
  NOTIFICATION_SIDEBAR: [],
  TEASE: [],
  BROWSER: []
};
const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initialNotificationState,
  reducers: {
    addNotification: (state, action) => {
      action.payload.notification.deliveryMethods.forEach(dm => {
        const method = DELIVERY_METHOD_CODE_MAP[dm];
        if (method !== DELIVERY_METHOD_NAMES.BANNER) {
          if (method) {
            state[method].push(action.payload.notification);
          }
        }
      });
    },
    removeNotification: (state, action) => {
      const {
        notification,
        deliveryMethod
      } = action.payload;
      if (deliveryMethod === DELIVERY_METHOD_NAMES.BANNER) {
        return state;
      }
      if (deliveryMethod) {
        return Object.assign({}, state, {
          [deliveryMethod]: state[deliveryMethod].filter(n => n.id !== notification.id)
        });
      }
      notification.deliveryMethods.forEach(dm => {
        const method = DELIVERY_METHOD_CODE_MAP[dm];
        if (method && method !== DELIVERY_METHOD_NAMES.BANNER) {
          state[method] = state[method].filter(n => n.id !== notification.id);
        }
      });
      return state;
    }
  }
});
export const getRealTimeNotifications = state => state.realTimeNotifications;
export const {
  addNotification,
  removeNotification
} = notificationsSlice.actions;
export default notificationsSlice.reducer;